import { Box, Button, FormControlLabel, Modal, styled, Switch } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import nomail from "../../Assets/nomail.svg"
import { APIUrlThree, APIUrlToken, GetOktaAuthData, GetUserId } from '../../Utils/Utils';
import axios from 'axios';
import { toast } from 'react-toastify';
const NotificationPreferenceModal = ({ setOpen, open, setLoading }) => {
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 350,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };
    const Android12Switch = styled(Switch)(({ theme }) => ({
        padding: 8,
        height: 42,
        width: 72,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            top: 8,
            left: 9,
            '&.Mui-checked': {
                transform: 'translateX(37px)',
                color: '#fff',
                top: 8,
                left: 0,
                '& + .MuiSwitch-track': {
                    backgroundColor: '#00A3E0',
                    opacity: 1,
                    border: 0,
                    ...theme.applyStyles('dark', {
                        backgroundColor: '#2ECA45',
                    }),
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100],
                ...theme.applyStyles('dark', {
                    color: theme.palette.grey[600],
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
                ...theme.applyStyles('dark', {
                    opacity: 0.3,
                }),
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 15,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    }));
    const [allJOIEmail, setAllJOIEmail] = useState(true);
    const [platformUpdates, setPlatformUpdates] = useState(true);
    const [dataEnrich, setDataEnrich] = useState(true);
    const [criePaths, setCriePaths] = useState(true);
    const [competitiveIntelligence, setCompetitiveIntelligence] = useState(true);
    const loggedUser = GetOktaAuthData()
    const GetNotificationPreferences = () => {
        setLoading(true);
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APIUrlToken()
            },
            url: `${APIUrlThree()}/v1/get_user_notification_preference?email=${loggedUser?.user?.profile?.username}`//email=paliwal@consultant.jobsohio.com`,
        };
        axios(option)
            .then((e) => {
                setAllJOIEmail(e?.data?.data?.[0]?.user_update_service)
                setPlatformUpdates(e?.data?.data?.[0]?.platform_updates)
                setDataEnrich(e?.data?.data?.[0]?.enrichment_service)
                setCriePaths(e?.data?.data?.[0]?.crie_service)
                setCompetitiveIntelligence(e?.data?.data?.[0]?.competitive_intelligence_service)
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    useEffect(() => {
        GetNotificationPreferences()
    }, [])
    const UpdateNotificationPreferences = () => {
        setLoading(true);
        const data = {
            "user_id": GetUserId(),
            "email": loggedUser?.user?.profile?.username,//paliwal@consultant.jobsohio.com,
            "crie_service": criePaths ? true : false,
            "enrichment_service": dataEnrich ? true : false,
            "competitive_intelligence_service": competitiveIntelligence ? true : false,
            "user_update_service": allJOIEmail ? true : false,
            "platform_updates": platformUpdates ? true : false
        }
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APIUrlToken()
            },
            data: data,
            url: `${APIUrlThree()}/v1/update_user_notification_preference`,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                setOpen(false);
                toast.success("Email Preferences Updated.")
            })
            .catch(() => {
                setLoading(false);
            });
    }
    const handleAllJOIEmail = (e) => {
        if (e) {
            setAllJOIEmail(e)
            setPlatformUpdates(true)
            setDataEnrich(true)
            setCriePaths(true)
            setCompetitiveIntelligence(true)
        } else {
            setAllJOIEmail(e)
            setPlatformUpdates(false)
            setDataEnrich(false)
            setCriePaths(false)
            setCompetitiveIntelligence(false)
        }
    }
    return (
        <>
            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style} style={{ overflowY: "auto", width: "40%" }}>
                        <div className="de_pad">
                            <h3 className='notification-email-head'>Email Notification Preferences <span onClick={() => setOpen(false)}><CloseIcon /></span></h3>
                            <p className='de_head-noti'>Decide what notification emails you would like to receive. </p>
                            <div className="notification-section-outer">
                                <div className="notification-section">
                                    <div className="no-inner-img">
                                        <img src={nomail} alt="mail" />
                                        <span>All JOI Notification Emails</span>
                                    </div>
                                    <div>
                                        <FormControlLabel
                                            control={
                                                <Android12Switch
                                                    checked={allJOIEmail}
                                                    onChange={(e) => { handleAllJOIEmail(e.target.checked) }}
                                                />
                                            }
                                            label=""
                                        />
                                    </div>
                                </div>
                                <div className="notification-section">
                                    <div className="no-inner-img">
                                        <img src={nomail} alt="mail" />
                                        <span>JOI Platform Updates/Enhancements</span>
                                    </div>
                                    <div>
                                        <FormControlLabel
                                            control={
                                                <Android12Switch
                                                    checked={platformUpdates}
                                                    onChange={(e) => setPlatformUpdates(e.target.checked)}
                                                />
                                            }
                                            label=""
                                        />
                                    </div>
                                </div>
                                <div className="notification-section">
                                    <div className="no-inner-img">
                                        <img src={nomail} alt="mail" />
                                        <span>Data Enrich Readiness</span>
                                    </div>
                                    <div>
                                        <FormControlLabel
                                            control={
                                                <Android12Switch
                                                    checked={dataEnrich}
                                                    onChange={(e) => setDataEnrich(e.target.checked)}
                                                />
                                            }
                                            label=""
                                        />
                                    </div>
                                </div>
                                <div className="notification-section">
                                    <div className="no-inner-img">
                                        <img src={nomail} alt="mail" />
                                        <span>CRIE Indirect Paths Readiness</span>
                                    </div>
                                    <div>
                                        <FormControlLabel
                                            control={
                                                <Android12Switch
                                                    checked={criePaths}
                                                    onChange={(e) => setCriePaths(e.target.checked)}
                                                />
                                            }
                                            label=""
                                        />
                                    </div>
                                </div>
                                <div className="notification-section">
                                    <div className="no-inner-img">
                                        <img src={nomail} alt="mail" />
                                        <span>Competitive Intel Expiration</span>
                                    </div>
                                    <div>
                                        <FormControlLabel
                                            control={
                                                <Android12Switch
                                                    checked={competitiveIntelligence}
                                                    onChange={(e) => setCompetitiveIntelligence(e.target.checked)}
                                                />
                                            }
                                            label=""
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="de_hr">
                                <div className='de_btn_cont'>
                                    <Button className='de_cancel' onClick={() => setOpen(false)}>Cancel</Button>
                                    <Button className='de_next' onClick={() => UpdateNotificationPreferences()} >Save</Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>
        </>
    )
}
export default NotificationPreferenceModal